export default "__VITE_ASSET__5dddbc8e__"